/* eslint-disable */
// TODO: Remove previous line and work through linting issues at next edit

module.exports = require('./script');

module.exports.Interpreter = require('./interpreter');
